import type { QueryObserverOptions } from "@tanstack/query-core";

/** Helper function to create query options with consistent typing */
export function queryOptions<TData>(options: QueryObserverOptions<TData>) {
  return options;
}
